import EnvironmentUtils from '@spothero/utils/environment';
import {window} from 'ssr-window';

const gmaps = EnvironmentUtils.isBrowser() ? window.google.maps : null;

export class MapRef {
    constructor(map) {
        this._map = map;
    }

    getBounds = () => {
        const bounds = this._map.getBounds();

        // Convert Mapbox bounds into Google Maps bounds
        return new gmaps.LatLngBounds(
            new gmaps.LatLng(
                bounds.getSouthWest().lat,
                bounds.getSouthWest().lng
            ),
            new gmaps.LatLng(
                bounds.getNorthEast().lat,
                bounds.getNorthEast().lng
            )
        );
    };
}
